import { FeatureFlagIds } from "../utils/featureFlagIds";
import { useSelector } from "react-redux";
import { AppState } from "../store/rootReducer";
import { useConfiguration } from "../Data/ConfigurationData";
import { isNil } from "lodash";
import { useOutstandingApplicationCustomerStipulations } from "../Data/StipulationData";
import { Constants } from "../utils/constants";
import { isAnyRequiredChecklistIncomplete } from "../utils/appUtils";
export const useStatusWorkflowUtils = () => {  
  const currentApp = useSelector((state: AppState) => state.applications.editingApp);
  const { data: configuration } = useConfiguration();
  const { data: outstandingAppCustomerStips } = useOutstandingApplicationCustomerStipulations(currentApp ? currentApp.id : Constants.emptyGuid);

  const preventDeskingOrPostingDueToIncompleteChecklist = currentApp &&
    configuration?.requiredChecklistsForDesking &&
    configuration.requiredChecklistsForDesking.length > 0
    ? isAnyRequiredChecklistIncomplete(configuration.requiredChecklistsForDesking, currentApp?.applicationChecklists)
    : false;

  const preventDeskingOrPostingDueToIncompleteStips = configuration && configuration.featureFlags?.[FeatureFlagIds.DisableDeskingIfRequiredStipsIncomplete] === true
    && (isNil(outstandingAppCustomerStips) || outstandingAppCustomerStips.some(oacs => oacs.numberOfDocumentsSubmitted < oacs.numberOfDocumentsRequired));

  const preventDeskingOrPosting = preventDeskingOrPostingDueToIncompleteChecklist 
    || preventDeskingOrPostingDueToIncompleteStips;

  return {
    preventDeskingOrPosting,
    preventDeskingOrPostingDueToIncompleteChecklist,
    preventDeskingOrPostingDueToIncompleteStips
  };
}